import Vue from 'vue'
import { NewspaperService, NewsService, CatService, CommentsService } from "@/common/api.service";
import { FETCH_LAST, FETCH_NEWSPAPERINFO, FETCH_NEWSPAPERS, FETCH_NEWS, FETCH_NEWSINFO, FETCH_CAT, RESET_CONFIG,UPDATESET_CONFIG, ADD_COMMENT } from "./actions.type";
import {
  FETCH_START,
  SET_CAT,
  SET_MSG,
  SET_NEWSPAPER,
  SET_NEWSPAPERS,
  SET_NEWSLIST,
  SET_NEWSINFO,
  SET_CONFIG,
  UPDATE_CONFIG,
} from "./mutations.type";

const state = {
  newspaper:[],
  newspapers:[],
  newslist:[],
  category:[],
  news: [],
  newsinfo: [],
  isShowBack:false,
  isShowFooter:true,
  isLoading: true,
  msg:'',
  newsCount: 0
};

const getters = {
  newsCount(state) {
    return state.newsCount;
  },
  newspaper(state) {
    return state.newspaper;
  },
  newspapers(state) {
    return state.newspapers;
  },
  newslist(state) {
    return state.newslist;
  },
  category(state) {
    return state.category;
  },
  news(state) {
    return state.news;
  },
  isShowBack(state) {
    return state.isShowBack;
  },
  isShowFooter(state) {
    return state.isShowFooter;
  },
  newsinfo(state) {
    return state.newsinfo;
  },
  msg(state) {
    return state.msg;
  },
  isLoading(state) {
    return state.isLoading;
  }
};

const actions = {
  async [ADD_COMMENT]({ commit }, comment) {
    commit(SET_MSG,'');
    await CommentsService.add(comment);
  },
  [FETCH_NEWSPAPERS]({ commit }, params) {
    commit(FETCH_START);
    return NewspaperService.getlist(params)
      .then(({ data }) => {
        commit(SET_NEWSPAPERS, data.data);
      })
      .catch(error => {
        commit(SET_MSG, error.response.data.msg);
      });
  },
  [FETCH_NEWSPAPERINFO]({ commit }, params) {
    commit(FETCH_START);
    return NewspaperService.getinfo(params)
      .then(({ data }) => {
        commit(SET_NEWSPAPER, data.data);
      })
      .catch(error => {
        commit(SET_MSG, error.response.data.msg);
      });
  },
  [FETCH_NEWS]({ commit }, params) {
    commit(FETCH_START);
    return NewsService.getlist(params)
      .then(({ data }) => {
        commit(SET_NEWSLIST, data.data);
      })
      .catch(error => {
        commit(SET_MSG, error.response.data.msg);
      });
  },
  [FETCH_NEWSINFO]({ commit }, params) {
    commit(FETCH_START);
    return NewsService.getinfo(params)
      .then(({ data }) => {
        commit(SET_NEWSINFO, data.data.data);
      })
      .catch(error => {
        commit(SET_MSG, error.response.data.msg);
        commit(SET_NEWSINFO,[]);
      });
  },
  [FETCH_CAT]({ commit }) {
    return CatService.get()
      .then(({ data }) => {
        commit(SET_CAT, data.data);
      })
      .catch(error => {
        commit(SET_MSG, error.response.data.msg);
      });
  },
  [FETCH_LAST]({ commit }) {
    
    commit(FETCH_START);
    return NewspaperService.getlast()
      .then(({ data }) => {
        commit(SET_NEWSPAPER, data.data);
      })
      .catch(error => {
        commit(SET_MSG, error.response.data.msg);
      });
  },
  [RESET_CONFIG] ({ commit }) {
    commit(SET_CONFIG)
  },
  [UPDATESET_CONFIG] ({ commit }, params) {
    commit(UPDATE_CONFIG,params)
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_START](state) {
    state.isLoading = true;
  },
  /* [FETCH_END](state, { articles, articlesCount }) {
    state.articles = articles;
    state.articlesCount = articlesCount;
    state.isLoading = false;
  }, */
  [SET_NEWSLIST](state, newslist) {
    state.newslist = newslist;
    state.isLoading = false;
  },
  [SET_NEWSINFO](state, newsinfo) {
    state.newsinfo = newsinfo;
    state.isLoading = false;
  },
  [SET_CAT](state, category) {
    state.category = category;
  },
  [SET_NEWSPAPER](state, newspaper) {
    state.newspaper = newspaper;
    state.isLoading = false;
  },
  [SET_NEWSPAPERS](state, newspapers) {
    state.newspapers = newspapers;
    state.isLoading = false;
  },
  [SET_CONFIG](state) {
    state.isShowBack = false
    state.isShowFooter = true
    state.msg = ''
  },
  [SET_MSG](state,data) {
    state.msg = data;
    state.isLoading = false;
  },
  [UPDATE_CONFIG] (state, data) {
    for (let f in data) {
      Vue.set(state, f, data[f])
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
